import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { withRouter } from '../../common/withRouter';
import { ButtonOBSOLETED, Notification, Message } from '../../web.common';
import PageTop from '../layout/PageTop';
import withApi from '../higherOrderComponents/withApi';

const cardStyle = {
  flex: '1 1 320px',
  background: '#fff',
  border: '1px solid #e0e0e0',
  borderRadius: 8,
  padding: 20,
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
};

const PlayInternal = (props) => {
  const [notification, setNotification] = useState(null);
  const [busy, setBusy] = useState(false);

  const handleDownload = async () => {
    setBusy(true);
    setNotification(null);
    try {
      await props.api.playReport.downloadCsv();
      setNotification(new Message('success', 'CSV downloaded'));
    } catch (e) {
      setNotification(new Message('error', `Download failed: ${e?.message || 'unknown error'}`));
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <Notification newMessage={notification} />
      <PageTop
        documentTitle='Play'
        documentDescription='Play admin section'
        mainHeadingContent='Play'
      />

      <div style={{ padding: 16, color: '#444', maxWidth: 980 }}>
        <p style={{ lineHeight: 1.5, marginBottom: 24 }}>
          Admin tools for the PLAY feature. Follow player-posted games and curated events, manage
          ambassador applications and export the full players dataset.
        </p>

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16 }}>
          <div style={cardStyle}>
            <h3 style={{ margin: 0, color: '#1a3559' }}>Games <span style={{ background: '#FF6A3D', color: '#fff', fontSize: 10, fontWeight: 'bold', borderRadius: 999, padding: '2px 8px', marginLeft: 6, verticalAlign: 'middle' }}>NEW</span></h3>
            <p style={{ margin: 0, color: '#666', fontSize: 14, lineHeight: 1.5, flex: 1 }}>
              Games posted by players (&quot;Suggest a game&quot;). Status, who joined each side, invites, payments and refunds, timeline.
            </p>
            <Link to='/play/games' style={{ display: 'inline-block' }}>
              <ButtonOBSOLETED buttonContent='Open games' />
            </Link>
          </div>

          <div style={cardStyle}>
            <h3 style={{ margin: 0, color: '#1a3559' }}>Events <span style={{ background: '#FF6A3D', color: '#fff', fontSize: 10, fontWeight: 'bold', borderRadius: 999, padding: '2px 8px', marginLeft: 6, verticalAlign: 'middle' }}>NEW</span></h3>
            <p style={{ margin: 0, color: '#666', fontSize: 14, lineHeight: 1.5, flex: 1 }}>
              Curated PLAY events (KSI Play Lunch, etc.). View signups + watchlist per session, generate / edit pairings, send pairings email.
            </p>
            <Link to='/play/events' style={{ display: 'inline-block' }}>
              <ButtonOBSOLETED buttonContent='Open events' />
            </Link>
          </div>

          <div style={cardStyle}>
            <h3 style={{ margin: 0, color: '#1a3559' }}>Ambassador applications</h3>
            <p style={{ margin: 0, color: '#666', fontSize: 14, lineHeight: 1.5, flex: 1 }}>
              Review pending applications, approve or decline. Filter by status to see history.
            </p>
            <Link to='/play/ambassador-applications' style={{ display: 'inline-block' }}>
              <ButtonOBSOLETED buttonContent='Open applications' />
            </Link>
          </div>

          <div style={cardStyle}>
            <h3 style={{ margin: 0, color: '#1a3559' }}>Players export</h3>
            <p style={{ margin: 0, color: '#666', fontSize: 14, lineHeight: 1.5, flex: 1 }}>
              Download a CSV of every PLAY profile — user info, sports, availability, affiliations,
              ambassador roles, dismiss state, invites count, timestamps.
            </p>
            <ButtonOBSOLETED
              onClick={handleDownload}
              disabled={busy}
              buttonContent={busy ? 'Downloading…' : 'Download CSV'}
            />
          </div>
        </div>
      </div>
    </>
  );
};

PlayInternal.propTypes = {
  api: PropTypes.object.isRequired,
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(withRouter(withApi(PlayInternal)));
